import { IUploadFileProps } from "./AddDocumentInterfaces";
import { Row, Col, Form } from "react-bootstrap";
import { useEffect, useState } from "react";

export default function UploadFile({ clear, onChange }: IUploadFileProps) {
  const [selectedRadio, setSelectedRadio] = useState("file");
  const [selectedUrl, setSelectedUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [urlWidth, setUrlWidth] = useState("40%");
  const [fileWidth, setFileWidth] = useState("40%");

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile = event.target.files;
    if (newFile && newFile.length > 0) {
      setSelectedFile(newFile[0]);
      if (selectedRadio === "file") onChange(selectedRadio, newFile[0], "file");
    }
  };
  const calculateWidth = (length: number) => {
    return Math.max(40, Math.min(100, length * 0.8));
  };

  useEffect(() => {
    const newWidth = `${calculateWidth(selectedUrl.length)}%`;
    setUrlWidth(newWidth);
  }, [selectedUrl]);

  useEffect(() => {
    const newWidth = `${calculateWidth(selectedFile?.name.length || 0)}%`;
    setFileWidth(newWidth);
  }, [selectedFile]);

  useEffect(() => {
    setSelectedRadio("file");
    setSelectedFile(null);
    setSelectedUrl("");
    onChange("", null, selectedRadio);
    const inputFile = document.getElementById("input-file") as HTMLInputElement;
    inputFile.value = "";
  }, [clear]);
  return (
    <>
      <Row className="padding-top">
        <Col xs={2}>
          <Form className={"custom-checkbox"}>
            <Form.Check
              id={"file"}
              type="radio"
              label={"Upload File"}
              checked={selectedRadio === "file"}
              onChange={(event) => {
                const checked = event.target.id;
                setSelectedRadio(checked);
                onChange(selectedUrl, selectedFile, "file"); // Call onChange with empty URL and selected file
              }}
            />
          </Form>
        </Col>
        <Col>
          <input
            id="input-file"
            type="file"
            onChange={onFileChange}
            disabled={selectedRadio !== "file"}
            className="form-control"
            style={{ width: fileWidth }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          <Form className={"custom-checkbox"}>
            <Form.Check
              id={"url"}
              type="radio"
              label={"URL"}
              checked={selectedRadio === "url"}
              onChange={(event) => {
                const checked = event.target.id;
                setSelectedRadio(checked);
                onChange(selectedUrl, null, "url");
              }}
            />
          </Form>
        </Col>
        <Col>
          <input
            id="input-url"
            type="text"
            value={selectedUrl}
            style={{ width: urlWidth }}
            onChange={(event) => {
              const newURL = event.target.value;
              setSelectedUrl(newURL);
              if (selectedRadio === "url") {
                onChange(newURL, selectedFile, "url");
              }
            }}
            placeholder="Enter URL"
            className="form-control"
            disabled={selectedRadio !== "url"}
          />
        </Col>
      </Row>
    </>
  );
}
